<template>
  <div class="Warp">
    <van-search
      v-model="keyword"
      show-action
      placeholder="请输入企业名称"
      @search="onSearch"
      @cancel="onCancel"
    />
    <van-grid :column-num="4" :border="false">
      <van-grid-item text="企业logo" />
      <van-grid-item text="企业名称" />
      <van-grid-item text="企业状态" />
      <van-grid-item text="企业员工" />
    </van-grid>
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了" 
        @load="uploader"
      >
        <div
          v-for="item in companyList"
          :key="item.company_id"
          @click="toDetail(item)"
        >
          <van-grid :column-num="4" :border="false">
            <van-grid-item>
              <van-image
                width="0.64rem"
                :src="img_base_url + item.company_logo"
              />
            </van-grid-item>
            <van-grid-item :text="item.company_name" />
            <!-- <van-grid-item class="compant_name" text="说的话就发了客户接受的了看见对方离开手机都发了看见了可上单就放开了" /> -->
            <van-grid-item
              :text="item.company_status == 1 ? '已开通' : '审核中'"
            />
            <van-grid-item
              text="点击查看"
              @click.stop="toCompanyConsumer(item.company_id)"
            />
          </van-grid>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      limit: 10,
      img_base_url: "",
      refreshLoading: false,
      loading: false,
      finished: false,
      companyList: [],
      keyword:'',
    };
  },
  mounted() {
    console.log(111);
    this.getImgBaseUrl();
    this.getCompanyList();
  },
  methods: {
    onSearch(v){
      this.keyword=v;
      this.page=1;
      this.companyList=[];
      this.getCompanyList();
    },
    onCancel(){
      this.keyword='';
      this.page=1;
      this.companyList=[];
      this.getCompanyList();        
    },
    getImgBaseUrl() {
      this.img_base_url = this.$store.state.imgUrl;
      console.log(this.img_base_url);
    },
    getCompanyList() {
      console.log(111);
      var reqData = {
        salesman_id: this.$cookies.get("salesmanInfo").id,
        page: this.page,
        limit: this.limit,
        keyword:this.keyword,
      };
      this.$http
        .get("/wechat/api.salesman/companyList", { params: reqData })
        .then((res1) => {
          var res = res1.body;
          console.log(res);
          res.data.rows.map((v) => {
            this.companyList.push(v);
          });
          this.loading = false;
          this.refreshLoading = false;
          if (this.companyList.length >= res.data.count) {
            this.finished = true;
          }
        });
    },
    // 下拉刷新
    onRefresh() {
      this.page = 0;
      this.companyList = [];
      this.finished = false;
      this.getCompanyList();
    },
    uploader() {
      this.page++;
      this.getCompanyList();
    },
    toDetail(item) {
      console.log("父级事件");
      this.$router.push({
        path: "/enterprise_detail",
        query: item,
      });
    },
    toCompanyConsumer(company_id) {
      console.log("子级事件");
      console.log(company_id);
      this.$router.push({
        path: "/companyConsumer",
        query: { id: company_id },
      });
    },
  },
};
</script>
<style lang="less" scoped>
// .compant_name{
//   // width:400px;
// }
/deep/ .van-grid-item__text {
  // width:px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>